import api from './api';

export const newsAPI = {
  // Get all news articles
  getAll: () => api.get('/news'),

  // Get single news article
  getById: (id) => api.get(`/news/${id}`),

  // Create news article
  create: (newsData) => api.post('/news', newsData),

  // Update news article
  update: (id, newsData) => api.put(`/news/${id}`, newsData),

  // Delete news article
  delete: (id) => api.delete(`/news/${id}`)
};

export const jobsAPI = {
  // Get all jobs
  getAll: () => api.get('/jobs'),

  // Get single job
  getById: (id) => api.get(`/jobs/${id}`),

  // Create job
  create: (jobData) => api.post('/jobs', jobData),

  // Update job
  update: (id, jobData) => api.put(`/jobs/${id}`, jobData),

  // Delete job
  delete: (id) => api.delete(`/jobs/${id}`)
};

export const teamMembersAPI = {
  // Get all team members
  getAll: (params) => api.get('/team-members', { params }),

  // Get single team member
  getById: (id) => api.get(`/team-members/${id}`),

  // Create team member
  create: (memberData) => api.post('/team-members', memberData),

  // Update team member
  update: (id, memberData) => api.put(`/team-members/${id}`, memberData),

  updateVisibility: (id, isActive) => api.patch(`/team-members/${id}/visibility`, { isActive }),

  // Upload team member image
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.post('/team-members/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // Reorder team members
  reorder: (orders) => api.put('/team-members/reorder/bulk', { orders }),

  // Delete team member
  delete: (id) => api.delete(`/team-members/${id}`)
};
